import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { STORE } from "@/data/store";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-secondary/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-display text-3xl font-bold tracking-tight">{STORE.name}</p>
          <p className="font-code text-[11px] uppercase tracking-[0.25em] text-terra mt-2">
            Heritage Kirana · Est. {STORE.est}
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed mt-5 max-w-sm">
            {STORE.tagline} Serving families with honest groceries, fair prices and
            farm-direct freshness for nearly five decades.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-code text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-home" className="link-underline" to="/">Home</Link></li>
            <li><Link data-testid="footer-link-products" className="link-underline" to="/products">Products &amp; Gallery</Link></li>
            <li><Link data-testid="footer-link-about" className="link-underline" to="/about">About Us</Link></li>
            <li><Link data-testid="footer-link-contact" className="link-underline" to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-code text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Reach Us</p>
          <ul className="space-y-4 text-sm">
            <li>
              <a data-testid="footer-email-link" href={`mailto:${STORE.email}`} className="flex items-center gap-3 hover:text-terra transition-colors duration-300">
                <Mail size={15} className="text-terra shrink-0" /> {STORE.email}
              </a>
            </li>
            <li>
              <a data-testid="footer-phone-link" href={`tel:+${STORE.phoneRaw}`} className="flex items-center gap-3 hover:text-terra transition-colors duration-300">
                <Phone size={15} className="text-terra shrink-0" /> {STORE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3 text-muted-foreground">
              <MapPin size={15} className="text-terra shrink-0 mt-0.5" />
              <span>{STORE.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-code text-xs text-muted-foreground tracking-wide">
            © {new Date().getFullYear()} {STORE.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs">
            <Link data-testid="footer-link-privacy" className="link-underline text-muted-foreground hover:text-foreground transition-colors" to="/privacy">Privacy Policy</Link>
            <Link data-testid="footer-link-disclaimer" className="link-underline text-muted-foreground hover:text-foreground transition-colors" to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
